<template>
    <div class="aside-bar-icons">
        <ul class="asider-bar-icons-list">
            <li class="icon-item" :class="{'active': active == 'overview'}">
                <inertia-link :href="route('helm-chart.view', {team: team, helm_chart: chart })">
                    <i class="feather-eye"></i>
                </inertia-link>
            </li>
<!--            <li class="icon-item" :class="{'active': active == 'templates'}">-->
<!--                <inertia-link :href="route('helm-chart.templates', {team: team, helm_chart: chart })">-->
<!--                    <i class="feather-sidebar"></i>-->
<!--                </inertia-link>-->
<!--            </li>-->
            <li class="icon-item" :class="{'active': active == 'versions'}">
                <inertia-link :href="route('helm-chart.versions', {team: team, helm_chart: chart })">
                    <i class="feather-rotate-ccw"></i>
                </inertia-link>
            </li>
            <li class="icon-item" :class="{'active': active == 'settings'}">
                <inertia-link :href="route('helm-chart.settings', {team: team, helm_chart: chart })">
                    <i class="feather-settings"></i>
                </inertia-link>
            </li>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "HelmChartSubMenu",
        props: ['team', 'chart', 'active']
    }
</script>

<style scoped>

</style>
